var _mask, _path, _path2, _rect, _rect2, _circle, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoryButtonIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3005_3066",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 35C28.2843 35 35 28.2843 35 20C35 11.7157 28.2843 5 20 5C11.7157 5 5 11.7157 5 20C5 22.7616 5.74629 25.3489 7.04819 27.5712L6.12863 33.7285C6.01493 34.4899 6.76806 35.0888 7.48426 34.8066L12.3339 32.8957C14.5773 34.2323 17.199 35 20 35Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 35C28.2843 35 35 28.2843 35 20C35 11.7157 28.2843 5 20 5C11.7157 5 5 11.7157 5 20C5 22.7616 5.74629 25.3489 7.04819 27.5712L6.12863 33.7285C6.01493 34.4899 6.76806 35.0888 7.48426 34.8066L12.3339 32.8957C14.5773 34.2323 17.199 35 20 35Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04819 27.5712L8.53174 27.7928L8.60988 27.2695L8.34245 26.813L7.04819 27.5712ZM6.12863 33.7285L7.61218 33.9501L6.12863 33.7285ZM7.48426 34.8066L8.03416 36.2022H8.03416L7.48426 34.8066ZM12.3339 32.8957L13.1016 31.6071L12.469 31.2302L11.784 31.5002L12.3339 32.8957ZM33.5 20C33.5 27.4558 27.4558 33.5 20 33.5V36.5C29.1127 36.5 36.5 29.1127 36.5 20H33.5ZM20 6.5C27.4558 6.5 33.5 12.5442 33.5 20H36.5C36.5 10.8873 29.1127 3.5 20 3.5V6.5ZM6.5 20C6.5 12.5442 12.5442 6.5 20 6.5V3.5C10.8873 3.5 3.5 10.8873 3.5 20H6.5ZM8.34245 26.813C7.1716 24.8144 6.5 22.4879 6.5 20H3.5C3.5 23.0353 4.32097 25.8834 5.75393 28.3294L8.34245 26.813ZM7.61218 33.9501L8.53174 27.7928L5.56464 27.3497L4.64508 33.507L7.61218 33.9501ZM6.93436 33.4111C7.29247 33.27 7.66903 33.5694 7.61218 33.9501L4.64508 33.507C4.36082 35.4104 6.24365 36.9077 8.03416 36.2022L6.93436 33.4111ZM11.784 31.5002L6.93436 33.4111L8.03416 36.2022L12.8838 34.2913L11.784 31.5002ZM20 33.5C17.4767 33.5 15.1193 32.8091 13.1016 31.6071L11.5661 34.1844C14.0353 35.6554 16.9213 36.5 20 36.5V33.5Z",
    fill: "#4480F7",
    mask: "url(#path-1-inside-1_3005_3066)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.0015,
    y: 17.643,
    width: 11.49,
    height: 1.5,
    rx: 0.75,
    fill: "#4480F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.0015,
    y: 21.643,
    width: 10,
    height: 1.5,
    rx: 0.75,
    fill: "#4480F7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 11,
    r: 6,
    fill: "#4480F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4545 8.73723C32.6557 8.92496 32.6557 9.22933 32.4545 9.41706L28.3342 13.2627C28.1331 13.4505 27.8069 13.4505 27.6058 13.2627L25.5456 11.3399C25.3445 11.1522 25.3445 10.8478 25.5456 10.6601C25.7468 10.4723 26.0729 10.4723 26.274 10.6601L27.97 12.243L31.7262 8.73723C31.9273 8.5495 32.2534 8.5495 32.4545 8.73723Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryButtonIcon);
export default __webpack_public_path__ + "static/media/category-button-icon.6d9495cdc4d2290fc93e3bc415cb65c9.svg";
export { ForwardRef as ReactComponent };